<script>
import Layout from "../../layouts/main";
import PageHeader from "../../components/page-header";
import VueSweetalert2 from "vue-sweetalert2";
import ErrorMessage from "../../components/error-message";
/**
 * Basic-table component
 */
export default {
  components: { ErrorMessage,Layout, PageHeader },
  data() {
    return {
      title: "Permission List",
      items: [
        {
          text: "Permission",
          href: "/",
        },
        {
          text: "Permission List",
          active: true,
        },
      ],
      permissions: [],
        errors:null,
        visible:false,
        message:"",
        search:"",
    };
  },
    computed: {
        filteredList() {
            return this.permissions.filter(permission => {
                return permission.name.toLowerCase().includes(this.search.toLowerCase())
                    || permission.type.toLowerCase().includes(this.search.toLowerCase())
                    || permission.tag.toLowerCase().includes(this.search.toLowerCase())
                    || permission.category.toLowerCase().includes(this.search.toLowerCase())
            })
        }
    },
  mounted() {
    this.getPermissionList();
  },
  methods: {
      onClose(){
          this.visible=false;
      },
      searchFilterFunc2(val) {
          this.search=val;
      },
    async deleteWarning(permission) {
      var _this = this;
      try {
        this.$swal({
          title: "Are you sure?",
          text: "You can't revert your action",
          type: "error",
          showCancelButton: true,
          confirmButtonText: "Yes, Delete it!",
          cancelButtonText: "No",
          showCloseButton: true,
          showLoaderOnConfirm: true,
        }).then((result) => {
          if (result.value) {
            _this.deleteItem(permission);
          } else {
            this.$swal("Cancelled", "", "info");
          }
        });
      } catch (err) {
        console.log(err);
      }
    },
    async getPermissionList() {
      try {
        axios
          .get("/api/permission_list", {
            params: {
              accessToken: localStorage.getItem("access_tocken"),
            },
          })
          .then((response) => {
            if (response.data.status) {
              this.permissions = response.data.data;
            } else {
              var str = response.data.message;
              var jsonParse = JSON.parse(str);
              this.errorCheck(jsonParse);
            }
          })
          .catch((error) => {
            console.log(error.message);
          });
      } catch (err) {
        console.log(err);
      }
    },
    errorCheck(obj) {
        if(obj.statusCode == 403){
            this.visible=true;
            this.message="Access Permission Denied";
            this.errors = obj.message;
        }else if (obj.error) {
        this.errors = obj.message;
      } else if (obj.message == "Token has expired") {
          this.$swal.fire({
              title: 'LogOut!',
              text: 'Token Has Expired',
              icon: 'error',
              toast:'true',
              position: 'top-end',
          });
        this.$router.push({ name: "logout" });
      } else if (obj.message !== "Token has expired") {
        this.errors = obj.message;
      } else {
        this.flashMessage.show({
          time: 5000,
          status: "error",
          title: "Error",
          message: "Problem in data load",
        });
      }
    },
    deleteItem: function deleteItem(permission) {
      var _this = this;
      axios
        .post("/api/permission_delete/" + permission.id, {
          accessToken: localStorage.getItem("access_tocken"),
        })
        .then(function (response) {
            if(response.data.status){
                _this.$swal.fire({
                    position: 'top-end',
                    icon: 'error',
                    title: 'Successfully Delete Permission',
                    showConfirmButton: false,
                    timer: 1000
                });
                _this.getPermissionList();
                _this.hasDeleted = false;
            } else {
                var str = response.data.message;
                var jsonParse = JSON.parse(str);
                _this.errorCheck(jsonParse);
            }

        });
    },
  },
};
</script>

<template>
  <Layout @CustomEventInputChangedAll="searchFilterFunc2">
    <PageHeader :title="title" :items="items" />
      <ErrorMessage :visible="visible" :errors="errors" v-on:close="onClose" :message="message"/>
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <div class="table-responsive table-responsive-sm">
              <table class="table mb-0 table-striped">
                <thead>
                  <tr>
                    <th>SL</th>
                    <th>Permission Name</th>
                    <th>Permission Type</th>
                    <th>Permission Tag</th>
                    <th>Permission Category</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(permission,index) in filteredList" v-bind:key="index">
                    <th scope="row">{{index+1}}</th>
                    <td>{{permission.name}}</td>
                    <td>{{permission.type}}</td>
                    <td>{{permission.tag}}</td>
                    <td>{{permission.category}}</td>
                    <td><router-link :to="{ name: 'permission_update', params: {id: permission.id } }" class="btn btn-primary btn-small"><i class="fas fa-edit"></i> Edit</router-link> <button @click.prevent="deleteWarning(permission)" class="btn btn-danger btn-small"><i class="fa fa-trash"></i> Delete</button></td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- end row -->
  </Layout>
</template>
